import { Box, Skeleton, Stack } from "@mui/material";

import UserBadge from "~/modules/user/components/UserBadge";

import { EmptyFieldworkerPlaceholder } from "./EmptyFieldworkerPlaceholder";
import { FieldworkerAssignmentsStatusMessage } from "./FieldworkerAssignmentStatusMessage";
import { FieldworkerAssignmentsFragment } from "./fragments.generated";

type FieldworkerAssignmentsHorizontalProps = {
    fieldworkers: FieldworkerAssignmentsFragment[];
    fieldworkersStillNeeded: number;
    fieldworkersRequired: number;
    size: "default" | "small";
};

export function FieldworkerAssignmentsHorizontal({
    fieldworkers,
    fieldworkersStillNeeded,
    fieldworkersRequired,
    size = "default",
}: FieldworkerAssignmentsHorizontalProps) {
    const marginBetweenAvatars = size === "small" ? -1 : -2;
    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: "auto auto",
                alignItems: "center",
                justifyContent: "space-between",
                columnGap: 2,
            }}
        >
            <Stack direction="row" alignItems="center" flexWrap="wrap" rowGap={1} sx={{ marginLeft: marginBetweenAvatars * -1 }}>
                {fieldworkers.map(fieldworker => (
                    <UserBadge
                        sx={{ marginLeft: marginBetweenAvatars }}
                        key={fieldworker.id}
                        names={[fieldworker.user.firstName, fieldworker.user.lastName]}
                        profilePicture={fieldworker.user.profilePictureMedia?.url}
                        size={size === "small" ? 25 : undefined}
                    />
                ))}
                {fieldworkersStillNeeded > 0 &&
                    Array.from({ length: fieldworkersStillNeeded }, (_, i) => i).map(number => (
                        <EmptyFieldworkerPlaceholder size={size} sx={{ marginLeft: marginBetweenAvatars }} key={number} />
                    ))}
            </Stack>
            <FieldworkerAssignmentsStatusMessage
                fieldworkersRequired={fieldworkersRequired}
                fieldworkersAssigned={fieldworkers.length}
                fieldworkersStillNeeded={fieldworkersStillNeeded}
            />
        </Box>
    );
}

export function FieldworkerAssignmentsHorizontalSkeleton() {
    return (
        <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Skeleton variant="circular" width={40} height={40} />
            <Skeleton variant="text" width={100} height={20} />
        </Stack>
    );
}
